export default "__VITE_ASSET__BRoKv7X7__"